import { render, staticRenderFns } from "./gamebox.vue?vue&type=template&id=65e23888"
import script from "./gamebox.vue?vue&type=script&lang=js"
export * from "./gamebox.vue?vue&type=script&lang=js"
import style0 from "./gamebox.vue?vue&type=style&index=0&id=65e23888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports